import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  AccountPayableAgentModel,
  AccountPayableLiteModel,
  AccountPayableModel,
  getAccountPayableAgentInput,
  getAccountPayableInput,
  getAccountPayablesInput,
} from './model';

export function useGetAccountPayables(
  input?: getAccountPayablesInput,
  options?: UseQueryOptions<
    ExtendedApiResult<AccountPayableLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<AccountPayableLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['account-payables', input?.params],
      () =>
        QueryFetchFunction({
          url: 'account-payables',
          params: input?.params,
        }),
      options,
    ),
    AccountPayableLiteModel,
  );
}

export function useGetAccountPayable(
  input?: getAccountPayableInput,
  options?: UseQueryOptions<ApiResult<AccountPayableModel>, ApiError>,
): UseQueryResult<ApiResult<AccountPayableModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['account-payables', input?.id],
      () =>
        QueryFetchFunction({
          url: `account-payables/${input?.id}`,
        }),
      options,
    ),
    AccountPayableModel,
  );
}

export function useGetAccountPayableAgent(
  input?: getAccountPayableAgentInput,
  options?: UseQueryOptions<ApiResult<AccountPayableAgentModel[]>, ApiError>,
): UseQueryResult<ApiResult<AccountPayableAgentModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      [
        'agents',
        input?.id,
        'payable-purchases',
        input?.params,
        ...(input?.othersKeys || []),
      ],
      () =>
        QueryFetchFunction({
          url: `agents/${input?.id}/payable-purchases`,
          params: input?.params,
        }),
      options,
    ),
    AccountPayableAgentModel,
  );
}

export function getAccountPayablesKey(input?: getAccountPayablesInput) {
  return ['account-payables', input?.params];
}

export function getAccountPayableKey(input?: getAccountPayableInput) {
  return ['account-payables', input?.id];
}

export function getAccountPayableAgentKey(input?: getAccountPayableAgentInput) {
  return [
    'agents',
    input?.id,
    'payable-purchases',
    input?.params,
    ...(input?.othersKeys || []),
  ];
}
